import { DateTime } from "luxon";
import { getUnionContractGivenWorkgroup } from "../workgroupMapper.js";
import { getCurrentFormScheduledStatus, isPendingBid } from "./bidCommon.js";

export const getReferenceNumberFromHref = () => {
  const uriList = window.location.href.split("/");
  return uriList[uriList.length - 1];
};

export const isBidWindowLessThanSevenDays = (windowDates) => {
  return windowDates[0] && windowDates[1] && windowDates[1].diff(windowDates[0], ["days"]).values.days < 7;
};

export const getSchedStartDateFromMonth = (schedMonth, schedYear, monthList) => {
  const converted_month = monthList.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);
  const date = DateTime.local(converted_year, converted_month).startOf("month");
  return date;
};

export const getSchedEndDateFromMonth = (schedMonth, schedYear, monthList) => {
  const converted_month = monthList.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);
  const date = DateTime.local(converted_year, converted_month).endOf("month");
  return date;
};

export const prepareBaseBidEventPayload = (bidData, bidName, schedMonth, schedYear, windowDates, monthList) => {
  return {
    ...(bidData.awardLog ? { awardLog: bidData.awardLog } : {}),
    bidName: bidName,
    bidType: bidData.bidType,
    referenceNumber: bidData.referenceNumber,
    schedMonth: schedMonth,
    schedYear: schedYear,
    station: bidData.station,
    ...(bidData.stationTier ? { stationTier: bidData.stationTier } : {}),
    status: bidData.status,
    windowStartDate: windowDates[0],
    windowEndDate: windowDates[1],
    workgroup: bidData.workgroup,
    unionContract: getUnionContractGivenWorkgroup(bidData.workgroup),
    v: bidData.v,
    schedStartDate: getSchedStartDateFromMonth(schedMonth, schedYear, monthList),
    schedEndDate: getSchedEndDateFromMonth(schedMonth, schedYear, monthList),
  };
};

export const addScheduledStatusToBidEvent = (bidEvent, bidStatus, isReadyToBeScheduledByUser) => {
  if (isPendingBid(bidStatus)) {
    bidEvent.scheduledStatus = getCurrentFormScheduledStatus(isReadyToBeScheduledByUser);
  }
  return bidEvent;
};

export const handleWindowDateTimeChange = (windowDates, timeValue, timeType) => {
  let newWindowStartDate = windowDates[0];
  let newWindowEndDate = windowDates[1];

  if (timeType === "hour") {
    newWindowStartDate = newWindowStartDate.set({ hour: parseInt(timeValue) });
    newWindowEndDate = newWindowEndDate.set({ hour: parseInt(timeValue) });
  } else if (timeType === "minute") {
    newWindowStartDate = newWindowStartDate.set({ minute: parseInt(timeValue) });
    newWindowEndDate = newWindowEndDate.set({ minute: parseInt(timeValue) });
  }

  return [newWindowStartDate, newWindowEndDate];
};

export const handleWindowDateChange = (event, windowDates, windowDateHr, windowDateMin) => {
  if (event[0] && !event[1]) {
    event[1] = event[0].plus({ days: 7 });
  }
  let newWindowStartDate = event[0];
  let newWindowEndDate = event[1];
  if (windowDates[0] && windowDates[1] && windowDateHr && windowDateMin) {
    newWindowStartDate = newWindowStartDate?.set({ hour: windowDateHr, minute: windowDateMin });
    newWindowEndDate = newWindowEndDate?.set({ hour: windowDateHr, minute: windowDateMin });
  }
  return [newWindowStartDate, newWindowEndDate];
};
